import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import BackButton from '../components/BackButton';

const BackButtonContainer = compose(
  withRouter,
  withHandlers({
    onClick: props => () => props.router.goBack(),
  }),
)(BackButton);

export default BackButtonContainer;



// WEBPACK FOOTER //
// ./src/app/kiosk/containers/BackButton.js